import { useEffect, useMemo } from "react";

import { useAppDispatch } from "store/index";
import { AIFileType, aiStateActions } from "store/slices/ai";

/**
 * This hook registers a file to the AI assistant.
 * For as long as the component is mounted. The AI assistant will send the files
 * along with every query.
 */
export const useAIFile = (files: AIFileType[]) => {
  const dispatch = useAppDispatch();

  // We assume ID+URL pairs are unique
  const fileIds = files.map((file) => file.url).join(",");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoedFiles = useMemo(() => [...files], [fileIds]);

  useEffect(() => {
    if (memoedFiles) {
      memoedFiles.forEach((file) => {
        dispatch(aiStateActions.setContextFile(file));
      });
    } else {
      memoedFiles.forEach((file) => {
        dispatch(aiStateActions.removeContextFile(file));
      });
    }
    return () => {
      memoedFiles.forEach((file) => {
        dispatch(aiStateActions.removeContextFile(file));
      });
    };
  }, [dispatch, memoedFiles]);
};
